import "./communication.css";
import ImageCarousel from "../../components/imageCarousel";
import { Link } from "react-router-dom";

export default function Communication() {
  return (
    <div className="combg">
      <h1
        className="text-7xl text-center text-black"
        style={{
          paddingTop: "120px",
          opacity: "0.8",
          color: "White",
          fontWeight: "1000",
        }}
      >
        Communication
      </h1>
      <div className="iback"></div>
      <ImageCarousel />

      <Link to="/teccem/education">
                <lable
                  className="btn text-lg mt-20 object-center justify-center"
                  style={{
                    color: "white",
                    backgroundColor: "transparent",
                    borderColor: "white",
                  }}
                >
                  Go to Education
                </lable>
      </Link>
    </div>
  );
}
